import axios from 'axios';
import get from 'lodash.get';

export type ProductRefreshStatus = {
  storeGuid: string;
  lastUpdated?: string | null;
};

export const getProductsRefreshStatus = (): Promise<ProductRefreshStatus[]> => {
  return axios.get('/store/productsRefreshStatus').then((response) => get(response, 'data', []));
};
